export enum EventKey {
  WallLoaded = 'wallLoaded',
  WallDataIsLoading = 'wallDataIsLoading',
  CartData = 'cartData',
  ShowPopup = 'showPopup',
  HidePopup = 'popupHidden',
  ToPreview = 'preview',
  TileClick = 'tileClick',
  TileSizeClick = 'tileSizeClick',
  TilesData = 'tilesData',
  TileDataUpdate = 'tileDataUpdate',
  RemovePreviewImage = 'remove-preview-image',
  ItemSelected = 'item-selected',
}
